export class AppSettings {
    public static ApiUrlPrefix = ApiUrlPrefix;
    public static DocumentApiUrlPrefix = DocumentApiUrlPrefix;
    public static GraphApiUrlPrefix = GraphApiUrlPrefix;
    public static SearchApiUrlPrefix = SearchApiUrlPrefix;
    public static AutoCorrectApiUrlPrefix = AutoCorrectApiUrlPrefix;
    public static AuthenticationApiUrlPrefix = AuthenticationApiUrlPrefix;
    public static IdentityApiUrlPrefix = IdentityApiUrlPrefix;
    public static SuggestionsApiUrlPrefix =  SuggestionsApiUrlPrefix;
    public static ProcessingApiUrlPrefix = ProcessingApiUrlPrefix;
    public static LocalStorageKey = LocalStorageKey;
    public static SettingsLocalStorageKey = SettingsLocalStorageKey;
    public static ApplicationInsightsInstrumentationKey = ApplicationInsightsInstrumentationKey;
    public static BugEmail = BugEmail;
    public static HelpLink = HelpLink;
    public static GoogleAnalytics = GoogleAnalytics;
    public static AppVersion = AppVersion;
    public static HelpScoutBeaconId = HelpScoutBeaconId;
    public static AccountsUrlPrefix = AccountsUrlPrefix;
    public static MaxApplicationRestarts = MaxApplicationRestarts;
    public static AppVersionWatchInterval = AppVersionWatchInterval;
    public static WindowOrigin = WindowOrigin;
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/app-settings.ts